function readMorePDP(){ 
  document.querySelector('.product-accordion__title.accordion--product-description').click();
}

if(document.body.classList.contains('hide_product')){
    document.querySelectorAll('.ProductForm .ProductForm__Actions, .ProductForm__Variants').forEach(el => el.classList.add('hidden'));
    window.location.href = window.location.origin;
}

// Retrive count of inventory of consultant warehouse
function inventory_based_location(){
  if(document.body.classList.contains('special_customer')){
    let inventoryCount;
    var atc_data = document.querySelector('.ProductForm__Actions button');
    if(atc_data){
       var wareHouse = atc_data.dataset.warehouse?.split(',');
       var customerWarehouse = atc_data.dataset.location; 
      const matchingWarehouse = wareHouse.find(item => item.includes(customerWarehouse));
      if(matchingWarehouse){
        inventoryCount = matchingWarehouse.split(':')[1];
      }
    }
    return inventoryCount;
  }
}

// Instock product of consultant warehouse in product page
if(document.body.classList.contains('special_customer')){
  var instockPDP = document.querySelector('.maxQuantity_pdp span');
  instockPDP ? instockPDP.textContent = inventory_based_location() : null;
}

// For Catalouge Page only
if(window.location.pathname == '/pages/catalogue') {
  setTimeout(function() {
    var iframe_links = document.querySelectorAll('.Container.ipaper-iframe iframe');
    var images = document.querySelectorAll('.image_textImage img');
    var anchor_tag = document.querySelectorAll('.redirectText_textImage a');
    images.forEach((ele, pos) => {
      ele.addEventListener('click', () => {
        var catalouge_link = iframe_links[pos].src;
        iframe_links.forEach((iframe, i) => {
          if(i !== pos) {
            iframe.parentElement.classList.add('hidden');
          }
        });
        iframe_links[pos].parentElement.classList.remove('hidden');
      });
    });
    images[0].click();
  }, 200);
}

// Changing from Quick Add to Sold out for Collection page 
if(window.location.pathname.includes('collections')){
  setTimeout(function(){
  var inventory_0 = document.querySelectorAll('.ProductItem .ProductItem__Action button');
    if(inventory_0){
      inventory_0.forEach(atc => {
        if(atc.dataset.stocked_quantity == 0){
          const url = atc.closest('.ProductItem__Wrapper').querySelector('.ProductItem__ImageWrapper').getAttribute('href');
          atc.parentElement.innerHTML = 
            `<a class="ProductItem__ActionButton Button Button--disabled Button--o Button--full" href="${url}">
              <span style="white-space: normal">Sold Out</span>
            </a>`;
        }
      })
    }
    
    var duplicate_taged_product = document.querySelectorAll('.ProductItem__Action.hideProduct');
    duplicate_taged_product.forEach(ele => {
      ele.closest('.Grid__Cell').classList.add('hidden');
      // console.log('ele',ele);
    })
    
    // Hide Recently view product at bottom
    var hide_privilage_recentView = document.querySelectorAll('.ProductItem__Action.hide_recentView');
    hide_privilage_recentView.forEach(item => {
      item?.closest('.Carousel__Cell')?.remove();
    })
  },4500)
}

if(document.body.classList.contains('special_customer') ){
  setTimeout(function(){
    var atc_marginPrice = document.querySelectorAll('.ProductItem__Action');
    atc_marginPrice.forEach(element => {
     var hasAttribute = element.hasAttribute('margin_amount');
     var getPercent_margin = element.getAttribute('margin_percentage');
      if(hasAttribute){
        const newPrice_off = element.getAttribute('margin_amount');
        // element.closest('.ProductItem__Wrapper').querySelector('.consultant-compare').textContent = newPrice_off;
        element.closest('.ProductItem__Wrapper').querySelector('.discount-tag .Product_discount').textContent = ` Member:${getPercent_margin}% Off`;
      }
    })
  }, 3000)
}

// if(window.location.pathname == '/products/one-touch-canister-set-diwali-special' ||
//    window.location.pathname ==  '/products/tupperware-aquasafe-bottle-750ml-set-of-2-2'
//   ){
//   // setTimeout(function(){
//     window.location.href = window.location.origin;
//   // }, 200)
// }

// if(window.location.pathname == '/products/aquasafe-water-bottles-750ml-set-of-4-copy'){
//   setTimeout(function(){
//     document.querySelectorAll('.ProductForm .ProductForm__Actions, .ProductForm__Variants').forEach(el => el.classList.add('hidden'));
//   }, 200)
// }

